import { Query } from '../../../../../hooks/queries'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../../api/connector'

interface EacGroupsArgs {
  organizationUuid: string
}

interface EacGroupsResponse {
  success: boolean
  messages: string[]
  custom_groups: {
    groups: any[]
  }
}

export async function getEacGroups(
  this: ThisConnector,
  { organizationUuid }: EacGroupsArgs
) {
  return this.connector.get(`${organizationUuid}/groups?expand=skip_links`)
}

export const useEacGroups = ({ organizationUuid }) => {
  const { isLoading, error, data } = useContrastQuery<
    EacGroupsArgs,
    EacGroupsResponse
  >([Query.EAC_GROUPS, organizationUuid], getEacGroups, { organizationUuid })

  return {
    isLoading,
    error,
    data
  }
}
